import Vue from 'vue'
import VueRouter from 'vue-router'

import store from "../store/index.js";

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    component() {
      return import(/* webpackChunkName: "login" */ "../views/users/LoginWeb.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 9,
    },
    name: "login"
  },
  {
    path: "/",
    component() {
      return import(/* webpackChunkName: "position-categories" */ '../views/discover/PositionsCategoryListWeb.vue');
    },
    meta: {
      allowAnonymous: true,
      level: 1,
    },
    name: "positions-web"
  },
  {
    path: "/logout",
    component() {
      return import(/* webpackChunkName: "logout" */ "../views/users/LogoutWeb.vue");
    },
    meta: {
      level: '41',
    },
    name: "logout",
  },
  {
    path: "/password_reset",
    component() {
      return import(/* webpackChunkName: "passwordreset" */ "../views/users/PasswordReset.vue");
    },
    meta: {
      allowAnonymous: true,
      level: '41',
    },
    name: "password_reset",
  },
  {
    path: '/position-categories',
    component() {
      return import(/* webpackChunkName: "position-categories" */ '../views/discover/PositionsCategoryListWeb.vue');
    },
    meta: {
      allowAnonymous: true,
      level: 2,
    },
    name: 'position-categories',
  },
  {
    path: '/positions',
    component() {
      return import(/* webpackChunkName: "positions" */ '../views/discover/PositionsListWeb.vue');
    },
    meta: {
      allowAnonymous: true,
      level: 3,
    },
    name: 'positions',
    props: true,
  },
  {
    path: '/positions/:id',
    component() {
      return import(/* webpackChunkName: "position-detail" */ '../views/discover/PositionDetailWeb.vue');
    },
    meta: {
      allowAnonymous: true,
      level: 5,
    },
    name: 'position-detail',
    props: true,
  },
  {
    path: "/inapppurchase",
    component() {
      return import(/* webpackChunkName: "inapppurchase" */ "../views/InAppPurchaseWeb.vue");
    },
    meta: {
      allowAnonymous:true,
      level: '41',
    },
    name: "inapppurchase",
    props: true,
  },

]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-line no-unused-vars
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (
    from.name !== null &&
    document.body.classList.contains('security-wall-modal-open')
  ) {
    // It appears that the user has tapped their (Android) device's back
    // button. We should ignore that.

    next(false);
    return;
  }

  store.commit("latestFromRoute", from);

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next();
  } else {
    if (store.state.userData === null) {
      next({
        name: "login",
        query: { next: to.fullPath }
      });
    } else {
      // Put in-app purchase logic stuff here, Only allow routes that are free. Otherwise
      // direct the user to In App Purchase screen.
      next();
    }
  }
});

router.afterEach((to) => {
  try {
    if (window.FirebasePlugin) {
      window.FirebasePlugin.setScreenName(to.path);
    }
  }
  catch (e) {} // eslint-disable-line no-empty
});


export default router
